import { QueryClient } from '@tanstack/react-query';

// Single QueryClient instance for the app. CRM-style data — slow-changing,
// not real-time — so we tune for fewer refetches and longer cache.
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 30_000,           // 30s — feels live without re-fetching on every focus
            gcTime: 5 * 60_000,          // 5min — keep data around so back-nav is instant
            refetchOnWindowFocus: false, // CRM, not a stock ticker
            refetchOnReconnect: 'always',
            retry: 1,
            retryDelay: 800
        },
        mutations: {
            retry: 0
        }
    }
});
